<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('internship_application')"
                        :isNewButton="checkPermission('internshipapplication_store')"
                        :isColumns="true"
                        @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('internship_application')"
                              :isNewButton="checkPermission('internshipapplication_store')"
                              :isColumns="true"
                              @filter-div-status="datatable.filterStatus = $event">
                    <div class="mb-1" v-for="(column,key) in datatable.columns">
                        <b-form-checkbox
                            :id="'checkbox-'+key"
                            :name="'checkbox-'+key"
                            :value="false"
                            :unchecked-value="true"
                            v-model="column.hidden"
                            v-if="column.field!='buttons'"
                        >
                            {{ column.label }}
                        </b-form-checkbox>
                    </div>
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :export-excel="checkPermission('internshipapplication_excelexport')"
                              @exportExcel="downloadExcel"
            >
                <b-row>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('faculty')">
                            <faculty-selectbox
                                v-model="datatable.queryParams.filter.faculty_code">
                            </faculty-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                       <b-form-group :label="$t('department')">
                            <department-selectbox
                                :faculty_code="datatable.queryParams.filter.faculty_code"
                                v-model="datatable.queryParams.filter.department_code"
                            ></department-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('program')">
                            <program-selectbox :faculty_code="datatable.queryParams.filter.to_faculty
                                " v-model="datatable.queryParams.filter.to_program" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('student_number')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.student_number"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('name')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.name"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('surname')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.surname"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('responsible_email')">
                            <b-form-input type="email"
                                          v-model="datatable.queryParams.filter.email"
                                          :placeholder="$t('email')"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('start_date')">
                            <b-form-input v-model="datatable.queryParams.filter.start_date" type="date"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('end_date')">
                            <b-form-input v-model="datatable.queryParams.filter.end_date" type="date"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>

            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />
            <CommonModal ref="showModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()" v-if="checkPermission('internshipapplication_show')">
                <template v-slot:CommonModalTitle>
                    {{ $t('show').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form :formId="formId"
                               v-if="formProcess=='show'"
                    />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';
    import DepartmentSelectbox from "@/components/interactive-fields/DepartmentSelectbox";
    import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox.vue";
    import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox";

    //Page
    import ShowForm from './ShowForm'

    //Service
    import InternshipApplicationService from '@/services/InternshipApplicationService';

    //Other
    import qs from 'qs';

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,
            DepartmentSelectbox,
            FacultySelectbox,
            ProgramSelectbox,

            ShowForm
        },
        metaInfo() {
            return {
                title: this.$t('internship_application')
            }
        },
        data() {
            return {
                formId: 0,
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('detail'),
                                    class: 'ri-search-eye-line',
                                    permission: "internshipapplication_show",
                                    callback: (row) => {
                                        window.open('/internship/applications/' + row.id, '_blank');
                                    }
                                },
                                {
                                    text: this.$t('show'),
                                    class: 'ri-search-eye-line',
                                    permission: 'internshipapplication_show',
                                    callback: (row) => {
                                        this.showForm(row.id);
                                    }
                                },
                            ]
                        },
                        {
                            label: this.toUpperCase('faculty'),
                            field: this.getLocaleField('faculty_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('department'),
                            field: this.getLocaleField('department_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('program'),
						    field: this.getLocaleField('program_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('student_number'),
                            field: 'student_number',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('name'),
                            field: 'name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('surname'),
                            field: 'surname',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('email'),
                            field: 'email',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('start_date'),
                            field: 'start_date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('end_date'),
                            field: 'end_date',
                            hidden: false
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return InternshipApplicationService.getAll(config)
                                       .then((response) => {
                                           this.datatable.rows = response.data.data;
                                           this.datatable.total = response.data.pagination.total;
                                       })
                                       .finally(() => {
                                           this.datatable.isLoading = false;
                                       });
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },
            showForm(id) {
                this.formId = id
                this.formProcess = 'show'
                this.$refs.showModal.$refs.commonModal.show()
            },
            downloadExcel() {
                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                InternshipApplicationService.downloadAsExcel(config)
                                .then(res => this._downloadFile(res, this.$t('classrooms') + '.xlsx'))
                                .catch(err => this.showErrors(err))
            }
        }
    }
</script>
